module.exports = __webpack_public_path__ + "img/wechat.01766a0b.png";